import React, { useEffect } from 'react'
import { Col } from 'react-bootstrap'
import { CheckCircleFill, Circle, GeoAltFill } from 'react-bootstrap-icons'
import { useSelector } from 'react-redux'
import { validatorIsCountedCustomer } from 'Utils/functions'

export const AddressOption = ({
  item,
  setLocation,
  location,
  showAddressDetail,
  clienteAddresses,
}) => {
  const [show, setShow] = React.useState(false)

  const useSelectorQuoteObject = useSelector(state => state?.cotizacion)

  const isCountedCustomer = validatorIsCountedCustomer(
    useSelectorQuoteObject?.QuoteHeader
  )

  const isSelectedDirection = !isCountedCustomer
    ? location?.AddressInfo?.AddressId === item?.AddressInfo?.AddressId &&
      clienteAddresses?.length === 1
    : clienteAddresses?.length === 1
  const addressStreet =
    item?.AddressInfo?.Street ||
    item?.AddressInfo?.AddressDetail ||
    item?.AddressInfo?.Address_AddressDetail

  const description = item.AddressInfo?.Name || item.AddressInfo?.Address_Street
  const alias =
    item.AddressInfo?.AddressDetail || item.AddressInfo?.Address_AddressDetail
  const country =
    item.AddressInfo?.CountryId || item.AddressInfo?.Address_CountryId
  const province =
    item.AddressInfo?.ProvinceId || item.AddressInfo?.Address_ProvinceId
  const district =
    item.AddressInfo?.DistrictId || item.AddressInfo?.Address_DistrictId
  const township =
    item.AddressInfo?.TownshipId || item.AddressInfo?.Address_TownshipId

  const invalidAddress = isCountedCustomer
    ? false
    : !(description && alias && country && province && district && township)

  useEffect(() => {
    if (isSelectedDirection) setLocation(item)
  }, [item])

  const handleEditAddress = () => {
    showAddressDetail({
      ...item?.AddressInfo,
      DefaultShippingAddress: item?.DefaultShippingAddress,
      DefaultBillingAddress: item?.DefaultBillingAddress,
    })
  }

  return (
    <div
      className="address-option-wrapper"
      data-testid="container-address-option">
      {!!addressStreet && (
        <div
          className="tooltip"
          style={show ? { visibility: 'visible' } : {}}
          onMouseEnter={() => setShow(true)}
          onMouseLeave={() => setShow(false)}
          data-testid="container-address-tooltip">
          {addressStreet}
          <button
            onClick={handleEditAddress}
            className="address-edit-button"
            data-testid="btn-edit-address">
            Editar
          </button>
        </div>
      )}
      <button
        className={
          isSelectedDirection
            ? 'direction-button-style-active'
            : 'direction-button-style-inactive'
        }
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        onClick={() => {
          isSelectedDirection && setLocation(null)
          if (invalidAddress) {
            handleEditAddress()
          } else {
            setLocation(item)
          }
        }}
        data-testid="btn-select-address">
        <Col className="direction-location-container col-6">
          <div>
            <GeoAltFill
              className={
                isSelectedDirection
                  ? 'pinpoint-location-active'
                  : 'pinpoint-location-inactive'
              }
            />
          </div>
          <div
            className={
              isSelectedDirection
                ? 'direction-text-style'
                : 'direction-text-style-inactive'
            }>
            {item.AddressInfo.Name ||
              addressStreet ||
              item.AddressInfo.Address_AddressDetail}
          </div>
        </Col>
        <Col className="sell-order-column-width">
          {isSelectedDirection ? (
            <CheckCircleFill className={'check-circle-active'} />
          ) : (
            <Circle className={'check-circle-inactive'} />
          )}
        </Col>
      </button>
    </div>
  )
}
